import React, { useContext, useRef } from "react";

import { observer } from "mobx-react";

import { useNotification } from "@utils/notifications";
import { PlayerSowStoreContext } from "@state/context/sow/PlayerSowStoreContext";
import { useTranslation } from "react-i18next";
export const SowDocumentUploadSection = observer(
	function SowDocumentUploadSection() {
		const inputRef = useRef<HTMLInputElement>(null);
		const { showError } = useNotification();

		const { t } = useTranslation();

		const playerSowStore = useContext(PlayerSowStoreContext);

		if (!playerSowStore) {
			return null;
		}

		const validateFiles = (files: File[] | FileList): boolean => {
			for (let file of files) {
				if (!playerSowStore.allowedTypes.includes(file.type)) {
					showError(
						t("PLAYER_SOW.UPLOAD_GUIDELINES.DOCUMENT_FORMATS")
					);

					return false;
				}

				if (file.size > playerSowStore.maxSize) {
					showError(t("PLAYER_SOW.UPLOAD_GUIDELINES.DOCUMENT_SIZE"));

					return false;
				}
			}

			return true;
		};

		const chooseFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
			e.persist();

			try {
				playerSowStore.setLoading(true);

				if (e.target.files) {
					if (!validateFiles(e.target.files)) {
						return;
					}

					const files = Array.from(e.target.files);
					const merge: File[] = [...files];
					playerSowStore.setFiles(merge);

					if (inputRef.current) {
						inputRef.current.value = "";
					}
				}
			} catch (err) {
				console.error(err);
			} finally {
				playerSowStore.setLoading(false);
			}
		};

		return (
			<div className="u-type--base u-mar--top--xsml">
				<input
					name="files"
					id="files"
					accept={playerSowStore.allowedTypes.join(", ")}
					type="file"
					multiple
					onChange={chooseFiles}
					ref={inputRef}
					className="u-display--none"
				/>
				<label
					htmlFor="files"
					className="card--primary__footer__btn btn btn--base btn--primary--inverted"
				>
					{t("PLAYER_SOW.ADD_DOCUMENTS")}
				</label>
			</div>
		);
	}
);
